import Library from './Library';

export default Library;
